// Referral status → CSS-module class key. The returned key matches a class in
// PatientReferralsPage.module.css (used as `styles[getReferralStatusKey(...)]`).
export const getReferralStatusKey = (status) => {
  if (["INTEGRATED_BROWSER", "DRAFT", "EXTERNAL"].includes(status)) {
    return "external";
  }
  if (status === "SENT") return "completed";
  if (status === "ACCEPTED") return "accepted";
  if (status === "REJECTED") return "rejected";

  return "undelivered";
};

// What the backend puts in ackReason when Healthlink's ACK carried no reason of its own.
const NO_DETAILS_REASON = "No specific error details provided in ACK response.";

export const HEALTHLINK_REFUSED = "Healthlink rejected this referral";

/**
 * Why Healthlink refused this referral, or null when there is nothing to say.
 *
 * Only for ERROR, Healthlink refusing the message (its ACK, KIN-2152). REJECTED is a hospital
 * turning the referral down after receiving it, a different thing that ackReason does not describe.
 * The reason can name the patient's PPSN; it is shown on the referral screens only, never logged.
 */
export const getHealthlinkRefusal = ({ status, ackReason } = {}) => {
  if (status !== "ERROR") return null;

  const reason = ackReason?.trim();

  if (!reason) return null;

  if (reason === NO_DETAILS_REASON) return HEALTHLINK_REFUSED;

  return reason;
};

// Human-readable referral status. INTEGRATED_BROWSER is surfaced as "Draft".
export const getDisplayStatus = (status) => {
  const displayStatus = status === "INTEGRATED_BROWSER" ? "DRAFT" : status;

  if (!displayStatus) return "-";

  return (
    displayStatus.charAt(0).toUpperCase() + displayStatus.slice(1).toLowerCase()
  );
};
